import { useContext } from 'react'

import { UserContext } from '@doist/marketist'

export type LazyBackgroundImageProps = {
    src: string
    webp?: string
    children: React.ReactNode
    className?: string
}

export default function LazyBackgroundImage({
    src,
    webp,
    children,
    ...rest
}: LazyBackgroundImageProps) {
    const { webpSupport } = useContext(UserContext)
    const resolvedSrc = webp && webpSupport ? webp : src

    return (
        <div style={{ backgroundImage: `url(${resolvedSrc})` }} {...rest}>
            {children}
        </div>
    )
}
